const formatMissingCert = (data, certNameList, splitByValue) => {
    let missingCertList = {};
    let newCertString = '';
    const certNames = data[certNameList].split(splitByValue);
    certNames.forEach((cert) => {
        cert = cert.trim();
        if (missingCertList[cert.slice(3)] === undefined) {
            missingCertList[cert.slice(3)] = `${cert.slice(0, 2)}.`;
        } else {
            const state = cert.slice(0, 2);
            missingCertList[cert.slice(3)] = missingCertList[cert.slice(3)].concat(' ', `${state}.`);
        }
    })
    const certListString = JSON.stringify(missingCertList);
    for (let i = 0; i < certListString.length; i++) {
        const re = /{|}|"|"/g;
        const reColon = /:/g;
        const reComma = /,/g;
        if (re.test(certListString[i])) {
            newCertString += certListString[i].replace(certListString[i], ' ');
        } else if (reColon.test(certListString[i])) {
            newCertString += certListString[i].replace(certListString[i], ' (');
        } else if (reComma.test(certListString[i])) {
            newCertString += ')\n';
        } else {
            newCertString += certListString[i];
        }
    }
    newCertString = newCertString.trim();
    newCertString += ' )\n';
    return newCertString;
}

export default formatMissingCert;
